import { ENV_DEVELOPMENT } from '@vfde-sails/constants';

declare let mtls: any;

/**
 * Starts Matelso Scanning
 */
export const maletsoScan = () => {
    if (process.env.NODE_ENV !== ENV_DEVELOPMENT) {
        if ('undefined' !== typeof mtls) {
            mtls.scan();
        }
    }
};
